import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'sc-wrapper-readonly',
  templateUrl: './wrapper-readonly.component.html',
  styleUrls: ['./wrapper-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WrapperReadonlyComponent extends FieldWrapper implements OnInit {
  ngOnInit(): void {}
}
